<template>
  <header
    v-if="hoverIsSupport && windowWidth > 1000"
    v-on:mouseleave="selectedRootCategoryId = undefined"
    ref="header"
    class="flex relative justify-center text-black"
  >
    <div class="pb-3">
      <template v-for="item in categoryTree" :key="item.category_id">
        <a
          v-if="item.top > 0"
          v-on:mouseover="
            () => {
              if (!hoverIsSupport) {
                return
              }
              if (!mouseMoved.moved.value) {
                  return
                }
              selectedRootCategoryId = item.category_id
              headerOutside = false
            }
          "
          @click="
            () => {
              if (!selectedRootCategoryId) {
                selectedRootCategoryId = item.category_id
                return
              }
              if (selectedRootCategoryId != item.category_id) {
                selectedRootCategoryId = item.category_id
                return
              }
              toLink(item.page_url)
            }
          "
          v-on:mouseleave="headerOutside = true"
          class="mx-4 text-2xl cursor-pointer underline-offset-8"
          :class="{ ['underline']: selectedRootCategoryId == item.category_id }"
        >
          {{ item.name }}
        </a>
      </template>
    </div>
    <div ref="headerBody" v-on:mouseleave="selectedSubCategory = undefined">
      <div
        v-show="selectedCategoryTree"
        class="absolute left-0 w-full py-3 text-xl pb-16 shadow-lg z-10 bg-white"
        :style="{ top: height + 'px' }"
      >
        <div class="mx-auto max-w-4xl p-5">
          <div
            v-if="selectedCategoryTree && treeHasChild(selectedCategoryTree?.children ?? [])"
            class="grid grid-cols-[350px_auto] gap-7"
          >
            <div>
              <ul class="">
                <template
                  v-for="(item, index) in selectedCategoryTree?.children ?? []"
                  :key="index"
                >
                  <li class="font-bold mb-5">
                    <a
                      class="cursor-pointer hover:text-red-600"
                      :class="{
                        ['underline']: selectedSubCategory?.category_id == item.category_id
                      }"
                      v-on:mouseover="
                        () => {
                          if (!hoverIsSupport) {
                            return
                          }
                          selectedSubCategory = item
                        }
                      "
                      @click="
                        () => {
                          if (!selectedSubCategory) {
                            selectedSubCategory = item
                            return
                          }
                          if (selectedSubCategory.category_id != item.category_id) {
                            selectedSubCategory = item
                            return
                          }
                          toLink(item.page_url)
                        }
                      "
                    >
                      {{ item.name }} <ChevronRightIcon class="h-5 w-5 inline" />
                    </a>
                  </li>
                </template>
              </ul>
            </div>
            <div>
              <template v-if="selectedSubCategory">
                <ul class="grid grid-cols-2 gap-4">
                  <template
                    v-for="subCatItem in selectedSubCategory?.children ?? []"
                    :key="subCatItem.category_id"
                  >
                    <li>
                      <a
                        @click="
                          () => {
                            toLink(subCatItem.page_url)
                          }
                        "
                        class="cursor-pointer hover:text-red-600 hover:underline"
                        >{{ subCatItem.name }}</a
                      >
                    </li>
                  </template>
                </ul>
              </template>
              <template v-else>
                {{ stripHtml(selectedCategoryTree.short_description ?? '').result }}
              </template>
            </div>
          </div>

          <div v-else>
            <div>
              <ul class="grid grid-cols-2 gap-4">
                <template
                  v-for="item in selectedCategoryTree?.children ?? []"
                  :key="item.category_id"
                >
                  <li>
                    <a
                      @click="
                        () => {
                          toLink(item.page_url)
                        }
                      "
                      class="cursor-pointer hover:text-red-600 hover:underline"
                      >{{ item.name }}</a
                    >
                  </li>
                </template>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
  <MainMobileMenuVue v-else :props="props.props"> </MainMobileMenuVue>
</template>
<script lang="ts" setup>
import { type MainMenuProps, type CategoryItemTree } from '@/types/book_item'
import { stripHtml } from 'string-strip-html'
import { buildTree, treeHasChild, toLink } from '@/components/MainMenu'
import MainMobileMenuVue from '@/components/MainMobileMenu.vue'
import { computed, ref } from 'vue'
import { useElementSize } from '@vueuse/core'
import { ChevronRightIcon } from '@heroicons/vue/24/solid'
import { hoverIsSupport } from '@/utils/utils'
import { useWindowSize } from '@vueuse/core'
import { useMouseMoved } from '@/utils/utils'

const props = defineProps<{
  props: MainMenuProps
}>()
const header = ref(null)
const headerOutside = ref(true)
const selectedRootCategoryId = ref<string | undefined>('')
const selectedSubCategory = ref<CategoryItemTree | undefined>()

const mouseMoved = useMouseMoved(10)

const { height } = useElementSize(header)
const { width: windowWidth } = useWindowSize()
const headerBody = ref(null)
const categoryTree = ref<CategoryItemTree[]>([])
categoryTree.value = buildTree(props.props.items)

const selectedCategoryTree = computed(() => {


  for (let i = 0; i < categoryTree.value.length; i++) {
    const v = categoryTree.value[i]
    if (v.category_id == selectedRootCategoryId.value) {
      return v
    }
  }
  return undefined
})


</script>
